<template>
	<!-- PageHeader -->
	<!-- <div class="page-header" :style="backgroundImageStyle"> -->
	<div class="page-header">
        <div class="row container">
            <div class="col-4 justify-content-center">
                <button class="btn btn-outline-light rounded-circle px-0 fs-4" @click="$emit('btnCallback')">
                    <i class="fas fa-home"></i>
                </button>
            </div>
            <div class="col-4">
                <div>
                    <i :class="icon"></i>
                    <div v-html="title"></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="input-group">
                    <input
                        v-model="searchText"
                        type="search"
                        class="form-control form-sm-control"
                        :placeholder="TR.search"
                        aria-label="Search"
                        @keyup="onInputEnter"
                    />
                    <button @click="searchButton" class="btn btn-secondary bg-site">
                        <i class="fas fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
	</div>
</template>


<script>
import { ref, watchEffect } from 'vue'
import { useRoute, useRouter } from "vue-router";

import { useStore } from '@/system_modules/store'

export default {
    name: 'PageHeader1C',
    props: {
        title: String,
        // pageimage: String,
        icon: String,
        // data: {
        //     type: Object,
        //     default: () => {}
        // }
    },
    // computed: {
    //     backgroundImageStyle() {
    //         return {
    //             backgroundImage: `url('${this.pageimage || '/assets/images/page-header.jpg'}')`
    //         };
    //     }
    // }
    setup(){
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const TR = ref();

        const searchText = ref("");

        searchText.value = route.params && route.params.search_text && route.params.search_text != '0' ? route.params.search_text : '';

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        const searchButton = () => {
            if( searchText.value.length > 1 ){
                router.push({
                    name: 'products_by_page',
                    params: {
                        page: 1,
                        perpage: 20,
                        category_id: 0,
                        year_min: 2025,
                        year_max: 2025,
                        quarters: 0,
                        price_min: 0,
                        price_max: 0,
                        sortfield: 'name',
                        sortorder: 1,
                        filters: '0',
                        search_text: searchText.value,
                    },
                    // query: {
                    //     search_text: searchText.value,
                    // }
                });
            }
        };

        const onInputEnter = (e) => {
            if (e.which == 13) {
                searchButton();
            }
        };

        return {
            TR,
            searchText,
            searchButton,
            onInputEnter,
        };
    }
}
</script>


<style lang="scss" scoped>
.page-header{
    background-repeat: no-repeat;
    background-size: cover;
    height: 60px;
    // background-image: linear-gradient(-30deg, rgb(255, 252, 250), rgb(21, 16, 16), rgb(21, 16, 16), rgb(255, 252, 250));
    background-image: linear-gradient(-30deg, rgb(255, 252, 250), rgba(var(--site-primary-color-rgb), .9), rgba(var(--site-primary-color-rgb), .9),  rgb(255, 252, 250));

    div{
        display: flex;
        justify-content: start;
        align-items: center;
        text-align: center;
        height: 100%;
        font-size: calc(var(--bs-body-font-size) * 1.9);
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 0.2rem;
    }
    div i{
        margin: 0 1rem 0rem 1rem;
    }

}
@media(max-width: 576px){
    .page-header{
        height: 100px;
    }
    div{
        font-size: calc(var(--bs-body-font-size) * 1.4);
        text-align: center;
    }
}
</style>